import React from 'react';
import { white } from '@salutejs/plasma-tokens-b2b';
import styled from 'styled-components';
var sizesRem = {
  s: 0.875,
  // 14px
  m: 1.25 // 20px

};

var DoneSvg = function DoneSvg(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    viewBox: "0 0 18 18",
    fill: "none",
    style: {
      width: "".concat(size, "rem")
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "m5.70711,8.15582c-0.39053,-0.39052 -1.02369,-0.39052 -1.41422,0c-0.39052,0.39053 -0.39052,1.02369 0,1.41422l3.70666,3.70666l6.71095,-6.70248c0.3908,-0.39027 0.3912,-1.02344 0.0009,-1.41421c-0.3903,-0.39077 -1.02344,-0.39117 -1.41421,-0.00089l-5.29674,5.29004l-2.29334,-2.29334z"
  }));
};

var IndeterminateSvg = function IndeterminateSvg(_ref2) {
  var size = _ref2.size,
      color = _ref2.color;
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    viewBox: "0 0 18 18",
    fill: "none",
    style: {
      width: "".concat(size, "rem")
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: "2",
    stroke: color,
    d: "m5.09449,9.0315l8,0"
  }));
};

var StyledRoot = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma-web-core__sc-1tdf2pn-0"
})(["display:inline-flex;"]); // TODO: https://github.com/salute-developers/plasma/issues/206

export var Done = function Done(_ref3) {
  var size = _ref3.size,
      _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? white : _ref3$color,
      className = _ref3.className;
  return /*#__PURE__*/React.createElement(StyledRoot, {
    className: className
  }, /*#__PURE__*/React.createElement(DoneSvg, {
    color: color,
    size: sizesRem[size]
  }));
}; // TODO: https://github.com/salute-developers/plasma/issues/206

export var Indeterminate = function Indeterminate(_ref4) {
  var size = _ref4.size,
      _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? white : _ref4$color,
      className = _ref4.className;
  return /*#__PURE__*/React.createElement(StyledRoot, {
    className: className
  }, /*#__PURE__*/React.createElement(IndeterminateSvg, {
    color: color,
    size: sizesRem[size]
  }));
};